var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"wrapper"},[_c('b-overlay',{attrs:{"show":_vm.sideBarLoading,"rounded":"sm"}},[_c('div',{staticClass:"container-fluid d-flex"},[_c('aside',[_c('side-bar-two')],1),_c('div',{staticClass:"main-cont"},[_c('div',{staticClass:"container-fluid"},[_c('router-view')],1)])])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }